import { createSlice, nanoid } from '@reduxjs/toolkit';

/**
 * Global UI state: toast notifications + responsive sidebar state.
 * Keeping toasts in Redux lets any thunk/component raise a notification
 * through the same channel.
 */
const initialState = {
  notifications: [],
  sidebarOpenMobile: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    notify: {
      reducer(state, action) {
        state.notifications.push(action.payload);
      },
      prepare({ type = 'info', message, title, duration = 4000 }) {
        return { payload: { id: nanoid(), type, message, title, duration } };
      },
    },
    dismissNotification(state, action) {
      state.notifications = state.notifications.filter((n) => n.id !== action.payload);
    },
    toggleMobileSidebar(state, action) {
      state.sidebarOpenMobile =
        action.payload !== undefined ? action.payload : !state.sidebarOpenMobile;
    },
  },
});

export const { notify, dismissNotification, toggleMobileSidebar } = uiSlice.actions;

export const selectNotifications = (state) => state.ui.notifications;
export const selectSidebarOpenMobile = (state) => state.ui.sidebarOpenMobile;

export default uiSlice.reducer;
